// extracted by mini-css-extract-plugin
export default {"sidebar":"NavSider_sidebar__2AhdE","logo":"NavSider_logo__2Xmc3","logoIcon":"NavSider_logoIcon__Ms10b","menu":"NavSider_menu__83kKt"};